import { FormControlLabel, Switch } from "@mui/material";
import { GraphOperatorFieldWrapper } from "../style/GraphOperator.styled";

export default function GraphOperatorFieldView({ 
    checkedSwitch,
    checkedExcludedDeliveryChargeSwitch,
    onActionChangeSwitch,
    onChangeExcludedDeliveryChargeSwitch
 }) {
    return (
        <GraphOperatorFieldWrapper>
            <div className='toggle-group'>
                <FormControlLabel labelPlacement="start" control={<Switch checked={checkedSwitch} onChange={() => onActionChangeSwitch()} />} label="주문 데이터 표시" />
                <FormControlLabel labelPlacement="start" control={<Switch checked={checkedExcludedDeliveryChargeSwitch} onChange={() => onChangeExcludedDeliveryChargeSwitch()} />} label="배송비 미포함" />
            </div>
        </GraphOperatorFieldWrapper>
    )
}